module.exports = __webpack_public_path__ + "img/bowl-hot.4862d73a.svg";